import { createContext, FC, ReactNode, useContext } from 'react';

export type ServerVarsContextType = {
    isDesktop?: boolean | null;
    isMobile?: boolean | null;
    isSbAdsEnabled?: boolean | null;
    isTablet?: boolean | null;
    clientConf?: { [key: string]: string | number | undefined } | null;
    localeOrigin?: string | null;
    isSearchQueryApplied?: boolean | null;
    locale?: string | null;
    originalUrl?: string | null;
    isSoldPDPV1Variant?: boolean | null;
    pdpPricingGuidanceVariant?: 'control' | 'variant-a' | 'variant-b' | null;
    isItemTileShorterHeight?: boolean | null;
    isNewNetPrice15Filter?: boolean | null;
};

export const ServerVarsContext = createContext<ServerVarsContextType>({
    isDesktop: null,
    isMobile: null,
    isSbAdsEnabled: null,
    isTablet: null,
    clientConf: {},
    localeOrigin: null,
    locale: null,
    originalUrl: null,
    isSearchQueryApplied: null,
    pdpPricingGuidanceVariant: null,
    isItemTileShorterHeight: null,
    isNewNetPrice15Filter: null,
});

export const useServerVarsContext = (): ServerVarsContextType => useContext(ServerVarsContext);

export const ServerVarsContextConsumer = ServerVarsContext.Consumer;

export const ServerVarsContextProvider: FC<ServerVarsContextType & { children: ReactNode }> = ({
    children,
    isDesktop,
    isMobile,
    isSbAdsEnabled,
    isTablet,
    clientConf,
    localeOrigin,
    originalUrl,
    isSearchQueryApplied,
    locale,
    isSoldPDPV1Variant,
    pdpPricingGuidanceVariant,
    isItemTileShorterHeight,
    isNewNetPrice15Filter,
}) => {
    return (
        <ServerVarsContext.Provider
            value={{
                isDesktop,
                isMobile,
                isSbAdsEnabled,
                isTablet,
                clientConf,
                localeOrigin,
                originalUrl,
                isSearchQueryApplied,
                locale,
                isSoldPDPV1Variant,
                isNewNetPrice15Filter,
                pdpPricingGuidanceVariant,
                isItemTileShorterHeight,
            }}
        >
            {children}
        </ServerVarsContext.Provider>
    );
};
